// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    // apiBaseUrl: 'https://superstudent-api.wehive.io/'
    apiBaseUrl: 'https://api.photomastersthegame.com/',
    uploadUrl: 'https://api.photomastersthegame.com/'

};

//        c.) Admin :https://dev-admin.suprstudent.club/login
// Api : https://dev-api.suprstudent.club/

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
